import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { makeStyles } from '@material-ui/core/styles';
import ReplayIcon from '@material-ui/icons/Replay';
import { TP } from '../../../constants/consts';
import { useTranslation } from '../../../src/i18n';
import { colors, fontSize } from '../../../constants/styleConstants';
import TextButton from '../../../components/TextButton';
import DateFilter from './dateFilter';

const useStyles = makeStyles({
  content: {
    backgroundColor: colors.lightGrey,
    '&:hover': {
      backgroundColor: colors.blue1,
    },
  },
  selected: {
    backgroundColor: `${colors.blue1} !important`,
    borderRight: `solid 5px ${colors.blue3}`,
    '&:hover': {
      backgroundColor: colors.blue1,
    },
    color: colors.blue3,
    fontWeight: 'bold',
  },
  icon: {
    color: colors.blue3,
    fontSize: fontSize.large,
  },
  customStyle: {
    textTransform: 'none',
    fontSize: fontSize.smallTitle,
    margin: '2px 4px 2px 0px',
    marginRight: '8px',
  },
  label: {
    marginLeft: '8px',
  },
  clearAllAction: {
    width: 60,
    height: 34,
    margin: '0px 8px 0 0',
    padding: '40px 2px',
    fontSize: fontSize.smallTitle,
    color: colors.darkBlue,
  },
});

export default function FBToggleList({
  state,
  dispatch,
  type,
  onSubmit,
  options,
  getSelectedValue,
  seasonsOptions,
  setToggleState,
}) {
  const classes = useStyles();
  const { t } = useTranslation();

  const selectedValue = getSelectedValue(state, type);

  const [selectedIndexToggle, setSelectedIndexToggle] = React.useState(selectedValue || null);
  React.useEffect(() => {
    setSelectedIndexToggle(selectedValue || null);
  }, [options]);

  const onSelectValue = (filterType, value) => {
    const filterTypes = {
      language_id: 'SELECT_LANGUAGE',
      subtitle_id: 'SELECT_SUBTITLE',
      country_id: 'SELECT_COUNTRY',
      year_id: 'SELECT_YEAR',
      season_id: 'SELECT_SEASON',
    };
    if (
      filterType === 'language_id' ||
      filterType === 'subtitle_id' ||
      filterType === 'country_id' ||
      filterType === 'year_id' ||
      filterType === 'season_id'
    ) {
      dispatch({
        type: filterTypes[filterType],
        payload: {
          additionalFilters: { [filterType]: value.id },
        },
      });
    }
  };
  const handleMenuItemClick = (filterType, index, id) => {
    setSelectedIndexToggle(id);
    onSubmit && onSubmit({ filterType, selectedValue: options[index] });
    onSelectValue(filterType, options[index]);
    setToggleState(false);
  };

  const resetSelection = (filterType, value) => {
    setSelectedIndexToggle(null);
    onSubmit && onSubmit({ filterType, selectedValue: value });
  };

  // Toggle bar

  const toggleOptionList = options?.length > 0 && (
    <>
      {options.map((option, index) => (
        <ListItem
          button
          key={option.id}
          selected={option.id === selectedIndexToggle}
          className={option.id === selectedIndexToggle ? classes.selected : classes.content}
          onClick={() => {
            handleMenuItemClick(type, index, option.id);
          }}
        >
          <ListItemText primary={option.name} />
        </ListItem>
      ))}
      <TextButton
        className={classes.clearAllAction}
        onClick={() => {
          resetSelection(type, -1);
        }}
      >
        <ReplayIcon></ReplayIcon>
        {t(`${TP}.FORM_CLEAR_ALL`)}
      </TextButton>
    </>
  );

  return (
    <>
      {type === 'date' ? (
        <DateFilter state={state} dispatch={dispatch} onSubmit={onSubmit} seasonsOptions={seasonsOptions} />
      ) : (
        toggleOptionList
      )}
    </>
  );
}
